import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import Icon from '@/components/Icon';
import { ShellContext } from '@/layout/AppShell';

export default function Topbar({
  breadcrumb = [],
  density,
  onDensityChange,
  viewMode,
  onViewModeChange,
}) {
  // Читаем контекст напрямую (не через useShell), чтобы Topbar не падал вне
  // AppShell. Гамбургер рисуем только если шелл умеет открывать мобильное меню.
  const shell = useContext(ShellContext);
  const toggleNav = shell?.toggleMobileNav;

  return (
    <div className="topbar">
      {toggleNav && (
        <button
          className="topbar__burger"
          onClick={toggleNav}
          title="Меню"
          aria-label="Открыть меню"
        >
          <Icon name="menu" size={18} />
        </button>
      )}
      <div className="topbar__breadcrumb">
        {breadcrumb.map((c, i) => {
          // Поддерживаем строки (как раньше) и объекты {label, to} для кликабельных крошек.
          const isObject = c && typeof c === 'object';
          const label = isObject ? c.label : c;
          const to    = isObject ? c.to    : null;
          const isLast = i === breadcrumb.length - 1;
          const cls = 'topbar__crumb' + (!isLast ? ' topbar__crumb--muted' : '');
          return (
            <React.Fragment key={i}>
              {i > 0 && <Icon name="chevron" size={10} />}
              {to && !isLast
                ? <Link to={to} className={cls}>{label}</Link>
                : <span className={cls}>{label}</span>}
            </React.Fragment>
          );
        })}
      </div>

      <div className="topbar__spacer" />

      <div className="topbar__actions">
        <button className="btn btn--ghost btn--icon" title="Поиск по всей системе">
          <Icon name="search" size={14} />
        </button>
        <button className="btn btn--ghost btn--icon" title="Уведомления">
          <Icon name="bell" size={14} />
          <span className="btn__dot" />
        </button>

        {(density !== undefined || viewMode !== undefined) && <div className="topbar__divider" />}

        {density !== undefined && (
          <div className="segmented" role="tablist" aria-label="Плотность">
            {['compact', 'cozy', 'spacious'].map((d) => (
              <button
                key={d}
                className={'segmented__btn' + (density === d ? ' is-active' : '')}
                onClick={() => onDensityChange?.(d)}
                title={d === 'compact' ? 'Компактно' : d === 'cozy' ? 'Средне' : 'Просторно'}
              >
                <span className={'segmented__icon segmented__icon--' + d}>
                  {d === 'compact' && <><span /><span /><span /><span /><span /></>}
                  {d === 'cozy' && <><span /><span /><span /><span /></>}
                  {d === 'spacious' && <><span /><span /><span /></>}
                </span>
              </button>
            ))}
          </div>
        )}

        {viewMode !== undefined && (
          <div className="segmented" role="tablist" aria-label="Вид">
            <button
              className={'segmented__btn segmented__btn--text' + (viewMode === 'table' ? ' is-active' : '')}
              onClick={() => onViewModeChange?.('table')}
            >Таблица</button>
            <button
              className={'segmented__btn segmented__btn--text' + (viewMode === 'cards' ? ' is-active' : '')}
              onClick={() => onViewModeChange?.('cards')}
            >Карточки</button>
          </div>
        )}
      </div>
    </div>
  );
}
